import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {gettext} from 'utils/text';
import {setCookie} from 'utils/cookie';
import reverseUrl from 'utils/urls';


class ProfileMenu extends React.Component {
    static propTypes = {
        user: PropTypes.shape({
            email: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            hasDashboardAccess: PropTypes.bool,
        }).isRequired,
        languageNeutralURL: PropTypes.string.isRequired,

        languageCode: PropTypes.string.isRequired,
        languages: PropTypes.arrayOf(PropTypes.shape({
            code: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })).isRequired,
    };

    state = {
        isOpen: false,
        isLanguageOpen: false,
    };

    onToggleLanguageSelect = () => this.setState({isLanguageOpen: !this.state.isLanguageOpen});
    onToggleSelect = () => this.setState({isOpen: !this.state.isOpen});
    onCloseSelect = () => this.setState({isOpen: false, isLanguageOpen: false});

    setLanguage = (languageCode) => {
        setCookie('django_language', languageCode);
    };

    renderLanguage = language => (
        <div key={language.code} className="dropdown--item">
            <a
                className="dropdown--link language text-capitalize"
                href={`/${language.code}${this.props.languageNeutralURL}`}
                onClick={() => this.setLanguage(language.code)}
            >
                {/* Language names are broken by default in django :/ */}
                {/* https://code.djangoproject.com/ticket/15714 */}
                <i className={`icon icon--country--${language.code}`} /> {language.label}
            </a>
        </div>
    );

    render() {
        const {user, languageCode, languages} = this.props;
        const {isOpen, isLanguageOpen} = this.state;

        const dropDownClasses = classNames('dropdown--menu profile--menu with-caret', {'dropdown--menu--open': isOpen});
        const languageDropDownClasses = classNames('dropdown--subitem', {'dropdown--subitem--open': isLanguageOpen});

        return (
            <div className="dropdown--wrapper">
                <a className="dropdown--toggle" onClick={this.onToggleSelect}>
                    {user.name || user.email} <span className={classNames('caret', {flip: isOpen})} />
                </a>
                {isOpen ? <div className="dropdown--backdrop" onClick={this.onCloseSelect} /> : null}
                <ul className={dropDownClasses}>
                    <li className="dropdown--item">
                        <a className="dropdown--link" href={reverseUrl('customer:order-list')}>
                            {gettext('Your orders')}
                        </a>
                    </li>
                    <li className="dropdown--item">
                        <a href={reverseUrl('customer:profile-update')} className="dropdown--link">
                            {gettext('Your account')}
                        </a>
                    </li>
                    {user.hasDashboardAccess ? (
                        <li className="dropdown--item">
                            <a className="dropdown--link" href={reverseUrl('dashboard:index')}>
                                {gettext('Dashboard')}
                            </a>
                        </li>
                    ) : null}
                    <li className="dropdown--item">
                        <a className="dropdown--link" onClick={this.onToggleLanguageSelect}>
                            {gettext('Language')}&nbsp;
                            (<span className="language-code">{languageCode}</span>)&nbsp;
                            <span className={classNames('caret', {flip: isLanguageOpen})} />
                        </a>
                        {isLanguageOpen ? (
                            <div className={languageDropDownClasses}>
                                {languages.map(this.renderLanguage)}
                            </div>
                        ) : null}
                    </li>
                    <li className="dropdown--item">
                        <a className="dropdown--link" href={reverseUrl('customer:logout')}>{gettext('Log out')}</a>
                    </li>
                </ul>
            </div>
        );
    }
}


export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/components/ProfileMenu.js